import Footer from "@/components/layout/Footer";
import Header from "@/components/layout/Header";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/context/AuthContext";
import { ImCoinDollar } from "react-icons/im";

import {
  ArrowLeft,
  Calendar,
  ClockAlert,
  Mail,
  MailCheck,
  MailX,
  RefreshCw,
  Reply,
  Users,
  HelpCircle,
  Play,
  Coins,
  Rocket,
  Zap,
  BadgeDollarSign,
  TrendingUp,
  TrendingDown,
  CoinsIcon,
} from "lucide-react";
import { useEffect, useMemo, useRef, useState } from "react";
import {
  FiActivity,
  FiAtSign,
  FiBarChart2,
  FiCalendar,
  FiMail,
  FiSend,
  FiServer,
  FiUsers,
  FiX,
  FiXCircle,
} from "react-icons/fi";
import { MdOutlineRocketLaunch } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import {
  campaignStatus,
  fetchCampaignById,
  fetchCampaignStatistics,
  resumeCampaign,
} from "../Redux/ReduxSlices/campaignSlice";
import gmailIcon from "../assets/images/gmail.webp";
import microsoftIcon from "../assets/images/outlook.webp";
import yahooIcon from "../assets/images/yahoopng.png";
import zohoIcon from "../assets/images/zohomail.png";
import EmailConnectModal from "../components/campaigns/EmailConnectModal";
import { OAuthPopup } from "../components/campaigns/OAuthPopup";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { toast } from "sonner";
import {
  fetchCustomEmailTemplateById,
  fetchFollowUpEmailById,
} from "../Redux/ReduxSlices/EmailTemplateSlice";
import {
  fetchCampaignMetrics,
  fetchCampaignRecipients,
} from "../Redux/ReduxSlices/emailMatrixSlice";
import { fetchUserDetails } from "../Redux/ReduxSlices/profileSlice";
import { fetchPaymentHistory } from "../Redux/ReduxSlices/paymentSlice";

// Mock campaign data
const COLORS = ["#10B981", "#E5E7EB"];

const getStatusColor = (status) => {
  switch (status) {
    case "active":
      return "bg-green-100 text-green-800 hover:bg-green-200 ";
    case "completed":
      return "bg-blue-300 text-blue-800 hover:bg-blue-200 ";
    case "paused":
      return "bg-yellow-100 text-yellow-800 hover:bg-yellow-200 ";
    case "draft":
      return "bg-gray-100 text-gray-800 hover:bg-gray-200 ";
    case "replied":
      return "bg-green-100 text-green-800 hover:bg-green-200 ";
    case "clicked":
      return "bg-blue-100 text-blue-800 hover:bg-blue-200 ";
    case "opened":
      return "bg-yellow-100 text-yellow-800 hover:bg-yellow-200 ";
    case "delivered":
      return "bg-gray-100 text-gray-800 hover:bg-gray-200 ";
    case "failed":
      return "bg-red-300 text-red-800 hover:bg-red-400 ";
    case "queued":
      return "bg-yellow-500 text-white hover:bg-yellow-600 ";
    case "sending":
      return "bg-[#37b783] text-white hover:bg-[#1d7350] text-sm";
    default:
      return "bg-gray-300 text-gray-900 hover:bg-gray-200 ";
  }
};

const StatCard = ({
  title,
  value,
  subtitle,
  icon: Icon,
  color = "text-black",
}) => (
  <Card>
    <CardContent className="p-4">
      <div className="flex md:items-center  justify-between">
        <div>
          <p className="text-sm font-medium text-black">{title}</p>
          <p className={`text-2xl font-bold ${color}`}>{value}</p>
          {subtitle && <p className="text-xs text-black mt-1">{subtitle}</p>}
        </div>
        <Icon className="h-8 w-8 max-md:h-6 max-md:w-6 text-black" />
      </div>
    </CardContent>
  </Card>
);

export default function CampaignDetailPage() {
  const providerLogos = {
    gmail: gmailIcon,
    outlook: microsoftIcon,
    zoho: zohoIcon,
    yahoo: yahooIcon,
  };
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const dispatch = useDispatch();
  // const { campaigns } = useCampaign();
  const [selectedTab, setSelectedTab] = useState("overview");
  const [showOAuthPopup, setShowOAuthPopup] = useState(false);
  const [showEmailConnectModal, setShowEmailConnectModal] = useState(false);
  const [showLaunchConfirmModal, setShowLaunchConfirmModal] = useState(false);
  const [selectedRecipients, setSelectedRecipients] = useState([]);
  const [spin, setSpin] = useState(false);
  const [open, setOpen] = useState(false);
  const [openBatch, setOpenBatch] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const clickCount = useRef(0);
  const clickTimer = useRef(null);
  const [openHelp, setOpenHelp] = useState(false);
  const [emailType, setEmailType] = useState("marketing");
  const { campaignStatusData } = useSelector((state) => state.campaign) || {};
  const [enableLaunch, setEnableLaunch] = useState(false);

  const {
    data: paymentResp,
    loading: paymentHistoryLoading,
    error: paymentHistoryError,
  } = useSelector((state) => state.userPayment);

  useEffect(() => {
    dispatch(fetchPaymentHistory());
  }, [dispatch]);
  // const getCampaignStatus = async () => {
  //   try {
  //     const response = await dispatch(campaignStatus(id)).unwrap();
  //     console.log("res", response);
  //   } catch (error) {
  //     console.log("eee", error);
  //   }
  // };

  useEffect(() => {
    dispatch(campaignStatus(id));
  }, []);

  useEffect(() => {
    if (campaignStatusData?.data) {
      setEnableLaunch(campaignStatusData?.data?.payment_required);
    }
  }, [campaignStatusData]);

  const {
    currentCampaign,
    campaigns = [],
    loading,
    campaignStats,
  } = useSelector((state) => state.campaign || {});
  const { metrics, datarecipients, error } = useSelector(
    (state) => state.campaignMetric,
  );

  const toggleBatch = (id) => {
    setOpenBatch(
      (prev) =>
        prev.includes(id)
          ? prev.filter((batchId) => batchId !== id) // close only this one
          : [...prev, id], // open this one
    );
  };

  // Find the campaign by ID

  const profile = useSelector((state) => state.profile.details);
  const {
    subject_data,
    body_data,
    footer_data,
    spam_score,
    loading: templateLoading,
    followUpEmailData,
  } = useSelector((state) => state.customEmail);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    // Call immediately on mount
    dispatch(fetchUserDetails());
    dispatch(fetchFollowUpEmailById(id));
  }, [dispatch]);

  const campaign =
    currentCampaign && currentCampaign.id === id
      ? currentCampaign
      : campaigns.find((c) => c.id === id) || {};

  useEffect(() => {
    if (id) {
      dispatch(fetchCampaignById(id));

      dispatch(fetchCampaignStatistics(id));
      dispatch(fetchCampaignMetrics(id));
      dispatch(fetchCampaignRecipients(id));
    }
  }, [dispatch, id]);

  const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
      const check = () => setIsMobile(window.innerWidth < 640); // Tailwind sm
      check();
      window.addEventListener("resize", check);
      return () => window.removeEventListener("resize", check);
    }, []);

    return isMobile;
  };

  const isMobile = useIsMobile();

  useEffect(() => {
    if (campaign?.template_id) {
      dispatch(fetchCustomEmailTemplateById(campaign.template_id));
    }
  }, [dispatch, campaign?.template_id]);

  const batches = useMemo(() => {
    return campaign?.batches || [];
  }, [campaign]);

  const formatDate = (dateString) => {
    if (!dateString) return "-";

    const date = new Date(dateString);
    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const shouldShowPaymentMessage =
    profile?.payment_gate?.has_payment_required &&
    profile?.payment_gate?.paywalled_campaigns?.some(
      (p) => p.id === campaign.id,
    );

  // ✅ Defensive optional chaining
  const dailyData =
    campaignStats?.series?.map((day) => {
      const dt = new Date(day.date);
      const month = dt.toLocaleString("en-US", { month: "short" });
      const dd = String(dt.getDate()).padStart(2, "0");

      return {
        date: `${month}-${dd}`, // Feb-19
        sent: day.totals.sent,
        failed: day.totals.failed,
        queued: day.totals.queued,
        attempted: day.totals.attempted,
        successRate: day.totals.success_rate * 100,
      };
    }) || [];

  const BAR_GROUP_WIDTH = 140; // adjust: 70–110 depending on spacing you want
  const chartMinWidth = Math.max(dailyData.length * BAR_GROUP_WIDTH, 650);

  const avgSuccessRate =
    dailyData.reduce((sum, d) => sum + d.successRate, 0) / dailyData.length;

  const pieData = [
    { name: "Success", value: Number(avgSuccessRate.toFixed(2)) },
    // { name: "Failure", value: Number((100 - avgSuccessRate).toFixed(2)) },
  ];

  const recipientCount = useMemo(() => {
    if (!campaign?.batches) return 0;

    // Just sum up recipients lengths (keep duplicates)
    return campaign.batches.reduce(
      (total, batch) => total + (batch.recipients?.length || 0),
      0,
    );
  }, [campaign]);

  useEffect(() => {
    if (!user) {
      navigate("/login");
    }
  }, [user, navigate]);

  const formatEmail = (email) => {
    if (!email) return "";

    const [username, domain] = email.split("@");

    const randomType = Math.random() > 0.5 ? 1 : 2;

    if (randomType === 1) {
      return `${username}@***`;
    }

    if (username.length <= 3) {
      return `${username[0]}**@****.${domain.split(".").pop()}`;
    }

    const first = username[0];
    const lastTwo = username.slice(-2);
    const maskedMiddle = "*".repeat(Math.max(username.length - 3, 2));

    const extension = domain.split(".").pop();

    return `${first}${maskedMiddle}${lastTwo}@****.${extension}`;
  };

  if (!user) {
    return null;
  }

  const handleLaunchCampaign = () => {
    if (!campaign?.id) {
      toast.warning("No campaign selected!");
      return;
    }
    setShowLaunchConfirmModal(true);
  };

  const handleRefresh = () => {
    if (disabled) return;

    // Count continuous clicks
    clickCount.current += 1;

    // Reset counter if user stops clicking
    if (clickTimer.current) clearTimeout(clickTimer.current);

    clickTimer.current = setTimeout(() => {
      clickCount.current = 0;
    }, 800); // 800ms gap resets count (you can adjust)

    // If 4 continuous clicks
    if (clickCount.current >= 5) {
      setDisabled(true);

      setTimeout(() => {
        setDisabled(false);
        clickCount.current = 0;
      }, 8000);
      return;
    }

    // Normal refresh logic
    setSpin(true);
    dispatch(fetchCampaignById(id));
    dispatch(fetchCampaignStatistics(id));
    dispatch(fetchUserDetails());

    setTimeout(() => setSpin(false), 400);
  };

  const startCampaign = async () => {
    try {
      const response = await dispatch(resumeCampaign(id)).unwrap();
      if (response?.success) {
        toast.success("Campaign resumed successfully!");
        await handleRefresh()
      } else {
        toast.error(response?.message || "Failed to resume campaign.", {
          duration: 4000, // 5 seconds
        });
        if (
          response?.message ===
          "No credits available. Please make a payment first."
        ) {
          setTimeout(() => {
            navigate("/pricing");
          }, 3000);
        }
      }
    } catch (error) {
      console.log("eee", error);
    }
  };

  // If campaign not found, show error
  if (!campaign && campaigns?.length > 0) {
    return (
      <div className="min-h-screen bg-white">
        <Header />
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-black mb-4">
              Campaign Not Found
            </h1>
            <p className="text-gray-600 mb-4">
              The campaign you're looking for doesn't exist.
            </p>
            <Button onClick={() => navigate("/campaigns")} className="">
              Back to Campaigns
            </Button>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 max-md:py-2">
        {/* Header */}
        <div className="mb-8 max-md:mb-6 max-md:pt-4">
          <div className="flex flex-col gap-4 mb-6">
            {/* Top Row */}
            <div className="flex items-center justify-between flex-wrap gap-3">
              {/* Left: Back + Title */}
              <div className="flex flex-col  items-start gap-3 flex-wrap">
                <button
                  onClick={() => navigate("/campaigns")}
                  className="flex items-center text-sm text-gray-600 hover:text-black"
                >
                  <ArrowLeft className="h-4 w-4 mr-1" />
                  Back
                </button>

                <h1 className="text-2xl font-bold text-black">
                  {campaign?.campaign_name || "Campaign"}
                </h1>
              </div>

              {/* Right: Actions */}
              <div className="flex items-center gap-2 flex-wrap">
                {/* Refresh */}
                <button
                  onClick={handleRefresh}
                  disabled={disabled}
                  className={`flex items-center gap-2 px-3 py-2 rounded-md border text-sm font-medium transition
          ${disabled
                      ? "text-gray-400 border-gray-200 cursor-not-allowed"
                      : "text-blue-600 border-blue-200 hover:bg-blue-50"
                    }
        `}
                >
                  <RefreshCw
                    className={`${spin ? "rotate-180" : ""} h-4 w-4`}
                  />
                  Refresh
                </button>

                {/* Help */}
                <button
                  onClick={() => setOpenHelp(true)}
                  className="flex items-center gap-2 px-3 py-2 rounded-md border text-sm font-medium text-gray-700 hover:bg-gray-100"
                >
                  <HelpCircle size={16} />
                  Help
                </button>

                {/* Primary CTA */}
                {!paymentResp?.total < 1 && (
                  <button
                    onClick={startCampaign}
                    disabled={!enableLaunch}
                    className={`
    group relative flex gap-2 justify-center items-center
    px-5 py-2.5 rounded-lg font-semibold text-sm
    transition-all duration-300 ease-out
    ${enableLaunch
                        ? "bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white shadow-md hover:shadow-xl active:scale-95 cursor-pointer"
                        : "bg-gray-200 text-gray-400 cursor-not-allowed"
                      }
  `}
                  >
                    <span>Resume Campaign (1</span>
                    <ImCoinDollar
                      size={16}
                      className={`transition-all duration-300 ${enableLaunch
                        ? "group-hover:translate-x-0.5 group-hover:scale-110"
                        : ""
                        }`}
                    />
                    )
                  </button>
                )}
              </div>
            </div>

            {/* Meta Info Row */}
            <div className="flex flex-wrap items-center gap-4 text-sm text-gray-600">
              <div className="flex items-center gap-1">
                <Calendar className="h-4 w-4" />
                Created {formatDate(campaign.created_at + "Z")}
              </div>

              <div className="flex items-center gap-1">
                <Mail className="h-4 w-4" />
                Sent{" "}
                {campaign.scheduled_at
                  ? formatDate(campaign.scheduled_at + "Z")
                  : "—"}
              </div>

              <Badge className={getStatusColor(campaign.status)}>
                {campaign.status === "sending"
                  ? "In Progress"
                  : campaign.status}
              </Badge>
            </div>
          </div>

          <Dialog open={openHelp} onOpenChange={setOpenHelp}>
            <DialogContent className="w-[calc(100%-32px)] max-w-lg rounded-2xl p-6 sm:w-full">
              <DialogHeader>
                <DialogTitle className="text-start text-xl font-semibold">
                  Campaign Workflow
                </DialogTitle>
                <DialogDescription className="text-start text-gray-700 text-base leading-relaxed space-y-2">
                  <ul className="list-disc ml-5 text-sm text-gray-700 space-y-2">
                    <li>
                      You get <strong>50 free emails</strong> to start.
                    </li>

                    <li>
                      After that, <strong>payment is required</strong> to
                      continue. If payment is pending, emails will not be sent.
                    </li>

                    <li>
                      Once payment is completed:
                      <ul className="list-disc ml-5 mt-1">
                        <li>
                          After completing the payment, go to the campaign you
                          want to resume, click the{" "}
                          <strong>'Resume Campaign'</strong> button — one credit
                          will be deducted, and your campaign will start.
                        </li>
                        <li>Day 1: 25 new emails are sent</li>
                        <li>Day 2: 25 new emails are sent</li>
                        <li>
                          Day 3 onwards: 50 emails per day (25 new + 25
                          follow-ups)
                        </li>
                      </ul>
                    </li>

                    <li>This continues till the end of the month.</li>

                    <li>
                      To continue in the next month, you need to{" "}
                      <strong>recharge again</strong>, and the same daily
                      sending rules will apply (25 new emails + 25 follow-ups
                      emails).
                    </li>

                    <li>
                      For new emails, your <strong>selected template</strong>{" "}
                      will be used. For follow-ups,{" "}
                      <strong>AI automatically generates emails</strong> based
                      on your original template.
                    </li>

                    <li>
                      Once all emails in the campaign are sent,{" "}
                      <strong>you will be notified</strong>.
                    </li>

                    <li>
                      You can <strong>track sent and queued emails</strong> in
                      the campaign graph.
                    </li>
                    <li>
                      Important: Do not change the password of your linked email
                      account{" "}
                      <span className="text-blue-600">
                        {campaign.send_from_email || ""}
                      </span>
                      , as all emails are sent from this account.
                    </li>
                  </ul>
                </DialogDescription>
              </DialogHeader>
            </DialogContent>
          </Dialog>

          {/* <div className="flex items-center justify-between w-full">
            <div className="w-full">
              <div className="flex justify-between items-center gap-4 mb-4 w-full max-md:flex-col max-md:items-start ">
                <h1 className="text-2xl max-md:text-xl font-bold max-md:font-semibold text-black mb-0">
                  {campaign?.campaign_name
                    ? campaign.campaign_name.charAt(0).toUpperCase() +
                      campaign.campaign_name.slice(1)
                    : "Campaign"}
                </h1>
                <button
                  onClick={() => startCampaign()}
                  disabled={!enableLaunch}
                  className={`
    group relative flex gap-2 justify-center items-center
    px-5 py-2.5 rounded-lg font-semibold text-sm
    transition-all duration-300 ease-out
    ${
      enableLaunch
        ? "bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white shadow-md hover:shadow-xl active:scale-95 cursor-pointer"
        : "bg-gray-200 text-gray-400 cursor-not-allowed"
    }
  `}
                >
                  <span>Resume Campaign (1</span>
                  <ImCoinDollar
                    size={16}
                    className={`transition-all duration-300 ${enableLaunch ? "group-hover:translate-x-0.5 group-hover:scale-110" : ""}`}
                  />
                  )
                </button>
              </div>

              <div className="flex items-center gap-2 mt-2">
                <div className="flex items-center max-md:items-start max-md:text-xs gap-1 text-sm text-black">
                  <Calendar className="h-4 w-4" />
                  Created{" "}
                  {campaign.created_at || campaign.sentDate
                    ? formatDate(
                        campaign.created_at + "Z" || campaign.sentDate + "Z",
                      )
                    : "—"}
                </div>

                <div className="flex items-center max-md:items-start gap-1 text-sm max-md:text-xs text-black">
                  <Mail className="h-4 w-4" />
                  Sent{" "}
                  {campaign.scheduled_at
                    ? formatDate(campaign.scheduled_at + "Z")
                    : "—"}
                </div>

                <Badge className={getStatusColor(campaign.status)}>
                  {campaign.status
                    ? campaign.status == "sending"
                      ? "In Progress"
                      : campaign.status.charAt(0).toUpperCase() +
                        campaign.status.slice(1).toLowerCase()
                    : ""}
                </Badge>
              </div>
            </div>
          </div> */}

          {campaign.status === "active" && (
            <div className="mt-6 flex gap-3 rounded-xl border border-green-200 bg-green-50 p-4 text-sm text-green-900 shadow-sm">
              <div>
                <p className=" text-green-800 leading-relaxed">
                  Congratulations! We’ll start sending{" "}
                  <span className="font-medium">50 emails per day</span> from
                  tomorrow until all emails are sent. Please do not change the
                  password of the OAuth-linked email during this time.
                </p>
              </div>
            </div>
          )}

          {campaign.status === "sending" && (
            <div className="mt-6 flex gap-3 rounded-xl border border-blue-200 bg-blue-50 p-4 text-sm shadow-sm">
              <div>
                <p className=" text-black-800 leading-relaxed font-semibold">
                  Your campaign is now active, with 50 emails being sent daily
                  from your account (25 new emails and 25 follow-ups). Please do
                  not change the password of the email account used to send
                  these emails.
                  <span className="text-blue-600">
                    {" "}
                    {campaign.send_from_email === null
                      ? ""
                      : campaign.send_from_email}{" "}
                  </span>{" "}
                  Also, click on Refresh to view the updated count.
                </p>
              </div>
            </div>
          )}

          {shouldShowPaymentMessage && (
            <div className="pt-4">
              <p className="text-xs font-semibold text-black cursor-pointer max-md:py-2 rounded-sm bg-gray-200 py-4 border text-center">
                Your free 50 emails have been sent successfully. To send the
                remaining emails for this campaign, please proceed with the
                payment and subscribe by{" "}
                <span
                  className="pl-2
                          underline font-bold
                          bg-gradient-to-r from-blue-600 via-purple-500 to-blue-600
                          bg-[length:200%_200%]
                          bg-clip-text text-transparent
                          animate-gradient"
                  onClick={() => navigate("/pricing")}
                >
                  Click Here
                </span>
                .
              </p>
            </div>
          )}
        </div>

        <Tabs
          value={selectedTab}
          onValueChange={setSelectedTab}
          className="space-y-6"
        >
          <TabsList className="grid w-full grid-cols-4 bg-white/80 backdrop-blur-sm rounded-md shadow-lg border border-black/20">
            <TabsTrigger
              value="overview"
              className="text-xs sm:text-sm font-bold px-1 sm:px-3 py-2 data-[state=active]:bg-gradient-to-r from-blue-600 to-indigo-600 data-[state=active]:text-white whitespace-nowrap"
            >
              <span className=" xs:inline">Overview</span>
            </TabsTrigger>
            <TabsTrigger
              value="recipients"
              className="text-xs sm:text-sm font-bold px-1 sm:px-3 py-2 data-[state=active]:bg-gradient-to-r from-blue-600 to-indigo-600 data-[state=active]:text-white whitespace-nowrap"
            >
              <span className=" xs:inline">Recipients</span>
            </TabsTrigger>
            <TabsTrigger
              value="content"
              className="text-xs sm:text-sm font-bold px-1 sm:px-3 py-2 data-[state=active]:bg-gradient-to-r from-blue-600 to-indigo-600 data-[state=active]:text-white whitespace-nowrap"
            >
              <span className=" xs:inline">Email Content</span>
            </TabsTrigger>
            <TabsTrigger
              value="settings"
              className="text-xs sm:text-sm font-bold px-1 sm:px-3 py-2 data-[state=active]:bg-gradient-to-r from-blue-600 to-indigo-600 data-[state=active]:text-white whitespace-nowrap"
            >
              <span className=" xs:inline">Info</span>
            </TabsTrigger>
          </TabsList>

          <TabsContent value="overview" className="space-y-6">
            {/* Key Metrics */}
            <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-6">
              <StatCard
                title="Total Recipients"
                value={campaign.total_recipients}
                icon={Users}
                className="p-"
              />
              <StatCard
                title="Send Emails"
                value={campaign?.email_progress?.sent}
                icon={MailCheck}
                color="text-blue-600"
              />
              <StatCard
                title="Email in queued"
                value={campaign?.email_progress?.queued}
                icon={ClockAlert}
                color="text-green-600"
              />
              <StatCard
                title="Failed Emails"
                value={campaign.email_progress?.failed}
                icon={MailX}
                color="text-yellow-600"
              />
              <StatCard
                title="Reply Rate"
                value={metrics?.events?.replies}
                icon={Reply}
                color="text-blue-600"
              />
            </div>

            {/* Performance Charts */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <Card className="p-0">
                <CardHeader>
                  <CardTitle className="max-md:text-xl">
                    Daily Performance
                  </CardTitle>
                </CardHeader>

                <CardContent className="p-0">
                  <div className="w-full overflow-x-auto">
                    <div
                      style={{ minWidth: chartMinWidth }}
                      className="h-[320px]"
                    >
                      <ResponsiveContainer width="100%" height="100%">
                        <BarChart
                          data={dailyData}
                          barCategoryGap="25%"
                          barGap={4}
                          margin={{ top: 10, right: 20, left: 0, bottom: 20 }}
                        >
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="date" interval={0} />
                          <YAxis allowDecimals={false} />
                          <Tooltip />
                          <Legend verticalAlign="top" height={36} />
                          <Bar
                            dataKey="sent"
                            fill="#2563EB"
                            radius={[6, 6, 0, 0]}
                          />
                          <Bar
                            dataKey="failed"
                            fill="#DC2626"
                            radius={[6, 6, 0, 0]}
                          />
                          <Bar
                            dataKey="queued"
                            fill="#F59E0B"
                            radius={[6, 6, 0, 0]}
                          />
                          <Bar
                            dataKey="attempted"
                            fill="#10B981"
                            radius={[6, 6, 0, 0]}
                          />
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="p-0">
                <CardHeader className="">
                  <CardTitle className="max-md:text-xl">
                    Campaign Performance: Success Rate
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-0">
                  <ResponsiveContainer
                    width="100%"
                    height={300}
                    className="max-md:-mt-10"
                  >
                    <PieChart>
                      <Pie
                        data={pieData}
                        cx="50%"
                        cy="50%"
                        innerRadius={0}
                        outerRadius={isMobile ? 80 : 120}
                        paddingAngle={0}
                        dataKey="value"
                        nameKey="name"
                        label={!isMobile && (({ value }) => `${value}%`)}
                      >
                        {pieData.map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={COLORS[index % COLORS.length]}
                          />
                        ))}
                      </Pie>
                      <Tooltip formatter={(value) => `${value}%`} />
                      <Legend verticalAlign="bottom" />
                    </PieChart>
                  </ResponsiveContainer>
                </CardContent>
              </Card>
            </div>

            <CardHeader className="pt-1 pb-0 px-1">
              <CardTitle className="max-md:text-xl">Campaign Details</CardTitle>
            </CardHeader>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-md:pb-8">
              {campaign?.batches
                ?.slice()
                .reverse()
                .map((batch, index) => (
                  <Card
                    key={batch.id}
                    className="p-4 rounded-xl shadow-lg border border-gray-100 hover:shadow-md transition-all duration-300 bg-gradient-to-br from-white to-gray-50/50"
                  >
                    <CardHeader className="p-0 pb-4">
                      <div className="flex flex-row justify-between items-start sm:items-center gap-4">
                        <div className="flex items-center gap-3 max-md:items-start">
                          <div className="p-2 bg-blue-100 rounded-lg">
                            <FiMail className="h-5 w-5 text-blue-600" />
                          </div>
                          <div>
                            <CardTitle className="text-lg mb-1 font-semibold text-gray-800">
                              Slot {index + 1}
                            </CardTitle>
                            <p className="text-xs text-gray-500 flex items-center mt-1 gap-1 max-md:items-start">
                              <FiCalendar className="h-3.5 w-3.5" />
                              {formatDate(batch.created_at + "Z")}
                            </p>
                          </div>
                        </div>
                        <Button
                          size="sm"
                          variant="outline"
                          className="rounded-lg gap-2 border-gray-300 hover:bg-blue-50 hover:text-blue-600 transition-colors max-md:text-xs max-md:font-bold"
                          onClick={() => {
                            setSelectedRecipients(batch.recipients);
                            setOpen(true);
                          }}
                        >
                          <FiUsers className="h-4 w-4" />
                          <span className="sm:hidden">
                            Recipients ({batch.recipients.length})
                          </span>
                          <span className="hidden sm:inline">
                            View Recipients ({batch.recipients.length})
                          </span>
                        </Button>
                      </div>
                    </CardHeader>
                    <CardContent className="p-0">
                      <div className="bg-white rounded-lg p-4 max-md:p-2 border border-gray-200 shadow-sm">
                        <h4 className="font-medium mb-3 text-gray-700 flex items-center gap-2 text-lg">
                          <FiBarChart2 className="h-4 w-4 text-green-600" />
                          Delivery Stats
                        </h4>
                        <div className="space-y-2 max-md:space-y-1">
                          <div className="flex justify-between items-center">
                            <span className="text-gray-600 text-sm flex items-center gap-2">
                              <FiAtSign className="h-3.5 w-3.5 text-blue-500" />
                              From Email:
                            </span>
                            <span className="font-medium text-gray-800 text-sm">
                              {batch.from_email}
                            </span>
                          </div>
                          <div className="flex flex-wrap items-center gap-6 max-md:gap-4">
                            <div className="flex items-center gap-2">
                              <FiServer className="h-3.5 w-3.5 text-purple-500" />
                              <span className="text-gray-600 text-sm">
                                Provider:
                              </span>
                              <span className="font-medium text-gray-800 text-sm flex items-center gap-2">
                                {providerLogos[
                                  batch.provider?.toLowerCase()
                                ] ? (
                                  <img
                                    src={
                                      providerLogos[
                                      batch.provider.toLowerCase()
                                      ]
                                    }
                                    alt={batch.provider}
                                    className="h-4 w-4"
                                  />
                                ) : (
                                  <FiServer className="h-4 w-4 text-gray-400" />
                                )}
                                {batch.provider
                                  ? batch.provider.charAt(0).toUpperCase() +
                                  batch.provider.slice(1).toLowerCase()
                                  : ""}
                              </span>
                            </div>
                            <div className="flex items-center gap-2">
                              <FiSend className="h-3.5 w-3.5 text-green-500" />
                              <span className="text-gray-600 text-sm">
                                Sent:
                              </span>
                              <span className="font-medium text-gray-800 text-sm">
                                {batch.sent_count}
                              </span>
                            </div>
                            {batch.failed_count !== 0 && (
                              <div className="flex items-center gap-2">
                                <FiXCircle className="h-3.5 w-3.5 text-red-500" />
                                <span className="text-gray-600 text-sm">
                                  Failed:
                                </span>
                                <span className="font-medium text-gray-800 text-sm">
                                  {batch.failed_count}
                                </span>
                              </div>
                            )}
                            <div className="flex items-center gap-2">
                              <FiActivity className="h-3.5 w-3.5 text-yellow-500" />
                              <span className="text-gray-600 text-sm">
                                Status:
                              </span>
                              <span
                                className={`font-medium text-sm px-3 py-1 rounded-full ${batch.status === "completed"
                                  ? "bg-green-100 text-green-800"
                                  : batch.status === "failed"
                                    ? "bg-red-100 text-red-800"
                                    : batch.status === "queued"
                                      ? "bg-yellow-200 text-yellow-800"
                                      : batch.status === "processing"
                                        ? "bg-blue-200 text-blue-800"
                                        : "bg-gray-100 text-gray-800"
                                  }`}
                              >
                                {batch.status
                                  ? batch.status.charAt(0).toUpperCase() +
                                  batch.status.slice(1)
                                  : ""}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                ))}
            </div>
          </TabsContent>

          <TabsContent value="recipients" className="space-y-6 max-md:pb-4">
            <Card>
              <CardHeader className="max-md:py-4">
                <CardTitle className="text-2xl font-semibold leading-none tracking-tight max-md:text-xl">
                  Recipient Details
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {batches.map((batch, index) => {
                    const isOpen = openBatch.includes(batch.id);
                    return (
                      <div
                        key={batch.id}
                        className={`rounded-lg border bg-gray-50 overflow-hidden ${isOpen ? "shadow-lg border-blue-100 max-h-full" : "h-12"}`}
                      >
                        <button
                          onClick={() => toggleBatch(batch.id)}
                          className="w-full flex items-center justify-between py-2 px-3 hover:bg-gray-100 transition"
                        >
                          <p className="text-base max-md:text-sm font-medium text-gray-800 mt-0.5">
                            Slot {index + 1}
                          </p>
                          <svg
                            className={`h-4 w-4 transition-transform duration-300 ${isOpen ? "rotate-180" : ""
                              }`}
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M19 9l-7 7-7-7"
                            />
                          </svg>
                        </button>
                        <div
                          className={`transition-all duration-300 ease-in-out ${isOpen
                            ? "max-h-96 p-4 pt-0 opacity-100"
                            : "max-h-0 opacity-0"
                            } overflow-y-auto`}
                        >
                          <div className="flex flex-wrap gap-2 mt-1">
                            {batch.recipients.map((email, i) => (
                              <span
                                key={i}
                                className="px-2 py-0.5 bg-indigo-50 border border-indigo-200 rounded text-xs text-gray-700"
                              >
                                {formatEmail(email)}
                              </span>
                            ))}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="content" className="space-y-6 max-md:pb-4">
            <Card className="">
              <CardHeader className="max-md:py-3">
                <div className="flex justify-between items-center w-full max-md:flex-col">
                  <CardTitle className="text-2xl font-semibold leading-none tracking-tight max-md:text-xl">
                    Email Content Preview
                  </CardTitle>
                  <div className="relative">
                    <div className="flex items-center gap-3 bg-gray-100/80 rounded-lg p-1 shadow-inner">
                      <button
                        onClick={() => setEmailType("marketing")}
                        className={`
                relative z-10 px-4 py-1.5 rounded-lg text-sm font-medium transition-all duration-300
                ${emailType === "marketing"
                            ? "text-white shadow-md"
                            : "text-gray-600 hover:text-gray-900"
                          }
              `}
                      >
                        Primary Outreach
                      </button>
                      <button
                        onClick={() => setEmailType("followup")}
                        className={`
                relative z-10 text-center px-4 py-1.5 rounded-lg text-sm font-medium transition-all duration-300
                ${emailType === "followup"
                            ? "text-white shadow-md"
                            : "text-gray-600 hover:text-gray-900"
                          }
              `}
                      >
                        Follow-up Email
                      </button>
                      <div
                        className={`
                absolute top-1 bottom-1 w-[calc(50%-4px)] rounded-lg bg-gradient-to-r from-blue-600 to-indigo-600
                transition-all duration-300 ease-out shadow-lg
                ${emailType === "marketing" ? "left-1" : "left-[calc(50%-2px)]"}
              `}
                      />
                    </div>
                  </div>
                </div>
              </CardHeader>
              {emailType == "marketing" ? (
                <CardContent className="max-md:p-2">
                  <div className="border rounded-lg p-6 bg-white">
                    <div className="border-b pb-4 mb-4">
                      <h3 className="font-bold text-lg max-md:text-sm">
                        {subject_data || "No subject"}
                      </h3>
                    </div>
                    <div className="prose max-w-none mt-2 max-md:text-sm">
                      <div
                        dangerouslySetInnerHTML={{ __html: body_data || "" }}
                      />
                      <div
                        className="mt-4 max-md:text-sm"
                        dangerouslySetInnerHTML={{ __html: footer_data || "" }}
                      />
                    </div>
                  </div>
                </CardContent>
              ) : (
                <CardContent className="max-md:p-2">
                  <div className="border rounded-lg p-6 bg-white">
                    <div className="border-b pb-4 mb-4">
                      <h3 className="font-bold text-lg max-md:text-sm">
                        {followUpEmailData?.subject_data || "No subject"}
                      </h3>
                    </div>
                    <div className="prose max-w-none mt-2 max-md:text-sm">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: followUpEmailData?.body_data || "",
                        }}
                      />
                      <div
                        className="mt-4 max-md:text-sm"
                        dangerouslySetInnerHTML={{
                          __html: followUpEmailData?.footer_data || "",
                        }}
                      />
                    </div>
                  </div>
                </CardContent>
              )}
            </Card>
          </TabsContent>

          <TabsContent value="settings" className="space-y-4 max-md:pb-4">
            <Card>
              <CardHeader className="max-md:p-3">
                <CardTitle className="max-md:text-xl max-md:px-2">
                  Campaign Information
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-16 max-md:gap-8 px-2">
                  <div>
                    <h4 className="font-medium mb-3">Basic Information</h4>
                    <div className="grid grid-cols-1 gap-4">
                      <div>
                        <label className="text-sm font-medium text-gray-600">
                          Campaign Name
                        </label>
                        <p className="text-sm mt-1">
                          {campaign.campaign_name
                            ? campaign.campaign_name.charAt(0).toUpperCase() +
                            campaign.campaign_name.slice(1)
                            : ""}
                        </p>
                      </div>
                      <div className="flex gap-5 items-center">
                        <label className="text-sm font-medium text-gray-600">
                          Status
                        </label>
                        <div className="">
                          <Badge className={getStatusColor(campaign.status)}>
                            {campaign.status
                              ? campaign.status == "sending"
                                ? "In Progress"
                                : campaign.status.charAt(0).toUpperCase() +
                                campaign.status.slice(1).toLowerCase()
                              : ""}
                          </Badge>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <h4 className="font-medium mb-3">Tracking Settings</h4>
                    <div className="space-y-3">
                      <div className="grid grid-cols-2 items-center">
                        <span className="text-sm text-gray-600">
                          Queued Tracking
                        </span>
                        <Badge className="justify-self-end bg-amber-100 text-amber-800 cursor-default">
                          {campaign?.email_progress?.queued ?? 0}
                        </Badge>
                      </div>
                      <div className="grid grid-cols-2 items-center">
                        <span className="text-sm text-gray-600">
                          Sent Tracking
                        </span>
                        <Badge className="justify-self-end bg-green-100 text-green-800 cursor-default">
                          {campaign?.email_progress?.sent ?? 0}
                        </Badge>
                      </div>
                      {campaign?.email_progress?.failed > 0 && (
                        <div className="grid grid-cols-2 items-center">
                          <span className="text-sm text-gray-600">
                            Failed Tracking
                          </span>
                          <Badge className="justify-self-end bg-red-100 text-red-800 cursor-default">
                            {campaign.email_progress.failed}
                          </Badge>
                        </div>
                      )}
                    </div>
                  </div>
                  <div>
                    <h4 className="font-medium mb-3">Provider Info</h4>
                    <div>
                      <div className="flex justify-between items-center">
                        <span className="text-gray-600 text-sm flex items-center gap-2">
                          <FiServer className="h-3.5 w-3.5 text-purple-500" />
                          Provider
                        </span>
                        <span className="font-medium text-gray-800 text-sm flex items-center gap-2">
                          {providerLogos[
                            campaign.send_via_provider?.toLowerCase()
                          ] ? (
                            <img
                              src={
                                providerLogos[
                                campaign.send_via_provider.toLowerCase()
                                ]
                              }
                              alt={campaign.send_via_provider}
                              className="h-4 w-4"
                            />
                          ) : (
                            <FiServer className="h-4 w-4 text-gray-400" />
                          )}
                          {campaign.send_via_provider
                            ? campaign.send_via_provider
                              .charAt(0)
                              .toUpperCase() +
                            campaign.send_via_provider.slice(1).toLowerCase()
                            : ""}
                        </span>
                      </div>
                      <div className="flex justify-between items-center mt-2">
                        <span className="text-gray-600 text-sm flex items-center gap-2">
                          <FiAtSign className="h-3.5 w-3.5 text-blue-500" />
                          From Email
                        </span>
                        <span className="font-medium text-gray-800 text-sm">
                          {campaign.send_from_email}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
        {campaign?.batches && campaign?.batches[0].queued_count > 0 && (
          <p className="mt-4 max-md:mt-2 max-md:text-base text-gray-800">
            Note: If the slot status shows 'Queued', it means the emails will be
            sent within the next 24 hours. Each slot includes 50 emails in
            total—25 follow-up emails and 25 fresh emails—based on the slot's
            assigned date.
          </p>
        )}
      </main>

      <Footer />
      <OAuthPopup
        open={showOAuthPopup}
        onClose={() => setShowOAuthPopup(false)}
        onConnectNow={() => {
          setShowOAuthPopup(false);
          setShowEmailConnectModal(true);
        }}
      />
      <EmailConnectModal
        open={showEmailConnectModal}
        onClose={() => setShowEmailConnectModal(false)}
      />

      <Dialog
        open={showLaunchConfirmModal}
        onOpenChange={setShowLaunchConfirmModal}
      >
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <MdOutlineRocketLaunch className="h-5 w-5 text-blue-600" />
              Launch Campaign
            </DialogTitle>
          </DialogHeader>
          <div className="py-4">
            <p className="text-gray-600">
              Are you sure you want to launch this campaign? This action will
              send emails to all recipients and cannot be undone.
            </p>
            {campaign?.name && (
              <div className="mt-3 p-3 bg-gray-50 rounded-lg">
                <p className="text-sm font-medium text-gray-900">
                  Campaign: {campaign.name}
                </p>
                <p className="text-sm text-gray-600">
                  Recipients: {campaign.recipient_emails?.length || 0} emails
                </p>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="w-[calc(100%-32px)] max-w-md sm:max-w-lg rounded-2xl p-5">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-lg font-semibold">
              <FiUsers className="h-5 w-5 text-blue-600" />
              Recipients List
            </DialogTitle>
          </DialogHeader>
          <div className="border rounded-lg divide-y max-h-72 overflow-y-auto mt-2">
            {selectedRecipients.map((email, i) => (
              <div
                key={i}
                className="p-3 flex items-center gap-3 hover:bg-gray-50 transition-colors"
              >
                <FiMail className="h-4 w-4 text-gray-400" />
                <span className="text-sm text-gray-700">
                  {formatEmail(email)}
                </span>
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
